import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
import { getUserActivityStats } from "common/services/analytics.service";

const LastDDSearch = () => {
  const [totalAgencies, setTotalAgencies] = useState(0);

  useEffect(() => {
    const fetchUserActivityStatsData = async () => {
      const response: any = await getUserActivityStats({
        typeOfRequest: "all",
      });
      if (response && response.data) {
        setTotalAgencies(response.data.totalAgencies);
      }
    };
    fetchUserActivityStatsData();
  }, []);

  return (
    <div className="col">
      <div className="py-4 px-3">
        <h5 className="text-muted text-uppercase fs-13">
          {"Total Agencies"}
          <i className={"ri-focus-line fs-18 float-end align-middle"}></i>
        </h5>
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0">
            <i className={"ri-earth-line display-6 text-muted cfs-22"}></i>
          </div>
          <div className="flex-grow-1 ms-3">
            <h2 className="mb-0 cfs-22">
              <span className="counter-value" data-target={totalAgencies}>
                <CountUp
                  start={0}
                  prefix={""}
                  suffix={""}
                  separator={""}
                  end={totalAgencies}
                  decimals={0}
                  duration={3}
                />
              </span>
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LastDDSearch;
